import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import Modal from "../modal";
import ImageUploadInput from "../inputs/image-upload";
import generateAvatarSVG from "../../utils/generate-avatar-svg";

class EditCycleModal extends React.Component {
  handleCycleTypeChange() {
    document.getElementById("add-cycle-form").reset();
  }

  render() {
    const {
      locals: { query, activeCycles, editCycle, activeUser, athlete },
    } = this.context;
    const { _id, description, image } = editCycle;
    const [firstName, lastName] = get(editCycle, "createdBy.name", "").split(
      / +/
    );
    const isAdmin = activeUser.hasRole("admin");
    return (
      <form
        id="add-cycle-form"
        action={`/actions/cycle/edit/${editCycle._id}?athlete=${
          athlete && athlete._id
        }`}
        method="POST"
        encType="multipart/form-data"
        data-noreset
        noValidate
      >
        <input type="hidden" name="_id" value={_id} />
        <Modal>
          <div className="head">
            <h2 className="alt">Edit Cycle Settings</h2>
          </div>

          <div className="body">
            <div className="Add-Cycle">
              <div className="group">
                <div className="label">Cycle Name</div>
                <input
                  name="name"
                  className="text-input"
                  defaultValue={editCycle.name}
                />
              </div>

              <div className="group">
                <div className="label">Description</div>
                <textarea
                  name="description"
                  className="textarea-input"
                  defaultValue={editCycle.description}
                ></textarea>
              </div>

              <div className="group alt-rm">
                <div className="label">Photo</div>
                <ImageUploadInput
                  name="image"
                  defaultValue={
                    editCycle.image || generateAvatarSVG(firstName, lastName)
                  }
                  required
                />
              </div>

              {isAdmin && (
                <div className="group">
                  <div className="columns">
                    <div className="column" data-col="1/2">
                      <div className="label">Type</div>
                      <select
                        name="type"
                        className="select-input"
                        defaultValue={editCycle.type || "user"}
                      >
                        <option value="premium">Premium</option>
                        <option value="standard">Standard</option>
                        <option value="user">User</option>
                        <option value="coach">Coach</option>
                      </select>
                    </div>
                    <div className="column" data-col="1/2">
                      <div className="label">Status</div>
                      <select
                        name="status"
                        className="select-input"
                        defaultValue={editCycle.status || "draft"}
                      >
                        {/* <option value="draft">Draft</option> */}
                        {/* <option value="submitted">Submitted</option> */}
                        <option value="published">Published</option>
                        <option value="created">Created</option>
                        <option value="archived">Archived</option>
                      </select>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="foot">
            <div className="columns">
              <div className="column" data-col="1/3">
                <a className="button alt" href="/actions/refresh?modal=">
                  Cancel
                </a>
              </div>

              <div
                className="column"
                data-col="1/3"
                style={{ textAlign: "center" }}
              ></div>

              <div
                className="column mobile-hidden"
                data-col="1/3"
                style={{ textAlign: "right" }}
              >
                <button type="submit" className="button-input">
                  Save
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </form>
    );
  }
}

EditCycleModal.contextTypes = { locals: PropTypes.object };

export default EditCycleModal;
